import React from 'react';
import { fmtEUR } from '../calculations/aquapodCalculations.js';

/**
 * Étape 4 : d'abord l'OPEX — est-ce que l'eau traitée coûte moins cher que l'eau du réseau,
 * indépendamment de l'investissement ? C'est la question business posée en premier par
 * l'utilisateur. Le CAPEX (Aquapod + plomberie) est affiché ensuite, dans la même étape.
 */
const BudgetStep = ({
  valorizedVolume, selectedModel, networkPrice, setNetworkPrice, opex, capex, nbConnectedPoints,
  currentStep, totalSteps, goPrevious, goNext, canAdvance,
}) => (
  <div className="apv2-step-card">
    <div className="apv2-step-header">
      <div className="apv2-step-header-text">
        <span className="apv2-step-eyebrow">Réutilisation des eaux grises</span>
        <h2 className="apv2-step-heading">Budget</h2>
      </div>
      <span className="apv2-step-counter">{currentStep + 1} / {totalSteps}</span>
    </div>
    <div className="apv2-step-body">

      <div className="rw-sub-label">Exploitation (OPEX)</div>
      <p className="apv2-sim-hint">
        Coût de l'eau traitée = forfait de maintenance annuel de l'Aquapod (6 000 €/an) réparti sur le volume
        réellement valorisé. À comparer directement au prix de l'eau du réseau, sans tenir compte de l'investissement.
      </p>

      <div className="rw-param-row">
        <div className="rw-param-field">
          <label>Prix de l'eau du réseau (€/m³)</label>
          <input
            type="number" step="0.1" min="0"
            value={networkPrice}
            onChange={(e) => setNetworkPrice(+e.target.value || 0)}
          />
        </div>
        <div className="rw-param-field">
          <label>Coût eau traitée avec Aquapod (€/m³)</label>
          <input type="number" value={opex.treatmentPricePerM3 != null ? opex.treatmentPricePerM3.toFixed(2) : '—'} disabled />
        </div>
      </div>

      <div className={`gw-viability-banner ${opex.isViable ? 'gw-viability-banner--ok' : 'gw-viability-banner--bad'}`}>
        {opex.treatmentPricePerM3 == null
          ? "Aucun volume valorisé pour l'instant — choisis un modèle Aquapod à l'étape 3."
          : opex.isViable
            ? `Rentable en exploitation : l'eau traitée (${opex.treatmentPricePerM3.toFixed(2)} €/m³) coûte moins cher que l'eau du réseau (${networkPrice.toFixed(2)} €/m³) — économie de ${fmtEUR(opex.annualSavings)} €/an sur ${valorizedVolume.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} m³ valorisés.`
            : `Non rentable en exploitation : l'eau traitée (${opex.treatmentPricePerM3.toFixed(2)} €/m³) coûte plus cher que l'eau du réseau (${networkPrice.toFixed(2)} €/m³) sur ce volume — l'investissement ne pourra pas s'amortir.`}
      </div>

      <div className="rw-sub-label" style={{ marginTop: 24 }}>Investissement (CAPEX)</div>
      <p className="apv2-sim-hint">
        Modèle retenu à l'étape 3 : <b>{selectedModel ? selectedModel.label : '—'}</b>. Plomberie et raccordement
        estimés à 300 €/point d'eau, pour les {nbConnectedPoints} point{nbConnectedPoints > 1 ? 's' : ''} sélectionné{nbConnectedPoints > 1 ? 's' : ''}
        {' '}(sources et débouchés confondus, étapes 1 et 2).
      </p>

      <div className="rw-result-area">
        <div className="rw-result-title">Estimation CAPEX</div>
        <div className="rw-breakdown">
          {capex.breakdown.map((row, i) => (
            <div className="rw-brow" key={i}>
              <span className="rw-bname">{row.name}</span>
              <span className="rw-bval">{fmtEUR(row.amount)} €</span>
            </div>
          ))}
          <div className="rw-total-row">
            <span className="rw-tname">Total CAPEX estimé</span>
            <span className="rw-tval">{fmtEUR(capex.total)} €</span>
          </div>
        </div>
      </div>
    </div>
    <div className="apv2-step-footer">
      <button type="button" className="apv2-footer-btn-ghost" onClick={goPrevious} disabled={currentStep === 0}>
        ← Précédent
      </button>
      <button type="button" className="apv2-footer-btn-cta" onClick={goNext} disabled={!canAdvance}>
        Suivant →
      </button>
    </div>
  </div>
);

export default BudgetStep;
